import React, { useEffect } from "react";
import { Gap, RefreshButton } from "../../atoms";
import SearchIcon from "@mui/icons-material/Search";
import ExcoCardView from "../../molecules/ExcoCardView";
import { getTableKabKot } from "../../../config/Redux/ExcoKabKot/actions";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@mui/styles";
import { PRIMARY } from "../../../utils/constansColors";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";
import "../../molecules/ExcoCardView/ExcoFilter.css";

const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: PRIMARY,
      color: "white",
      border: "none",
    },
  },
  tableBody: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    fontSize: "25px",
    borderRadius: 5,
  },
  tableHeader: {
    backgroundColor: "transparant",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    color: "#757575",
    fontWeight: 700,
  },
});

const ExcoKabKot = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [search, setsearch] = React.useState("");
  const [sortBy, setSortBy] = React.useState("nama_kantor");
  const [sortType, setSortType] = React.useState("asc");
  const [filterProvince, setProvince] = React.useState("0");
  const dataExcoKabKot = useSelector((state) => state.excokabkot.dataKabKot);
  const listProvinsi = useSelector((state) => state.global.dataProvince);
  const provinces = [
    { kode_prov_bps: 0, nama_prov_kemdagri: "Semua Provinsi" },
  ];

  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  let levelExco = profile?.data?.id_tingkat_exco;
  let profileProvince = profile?.data?.id_provinsi;
  if (levelExco === 1) {
    for (let i = 0; i < listProvinsi.data?.length; i++) {
      provinces.push(listProvinsi.data[i]);
    }
  } else if (levelExco >= 2) {
    for (let i = 0; i < listProvinsi.data?.length; i++) {
      if (profileProvince === listProvinsi.data[i].kode_prov_bps) {
        provinces.push(listProvinsi.data[i]);
      }
    }
  }

  const handlePagination = async (event, value) => {
    var url = new URL(window.location.href);
    var page = url.searchParams.get("page");
    if (page) {
      url.searchParams.set("page", value);
    } else {
      url.searchParams.append("page", value);
    }
    window.history.pushState({}, null, url);

    setCurrentPage(value);
    setLoading(true);
    let a = await dispatch(
      getTableKabKot(
        `kota-kabupaten`,
        value,
        search,
        sortBy,
        sortType,
        filterProvince,
      ),
    );
    if (a) {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      var url_string = window.location.href;
      var url = new URL(url_string);
      var page = url.searchParams.get("page");
      var sort_type = url.searchParams.get("sort_type");
      var sort_by = url.searchParams.get("sort_by");
      var search_by = url.searchParams.get("search_by");
      var province = url.searchParams.get("province");

      if (province) {
        setProvince(province);
      }
      setsearch(search_by);

      // Check if data already exists in Redux (cache check)
      const currentCachePage = dataExcoKabKot?.data?.current_page;
      const requestedPage = page ? parseInt(page) : 1;

      // Skip API call if data exists and page matches, and no active filters/search
      if (
        dataExcoKabKot?.data?.data?.length &&
        currentCachePage === requestedPage &&
        !search_by &&
        !province
      ) {
        setCurrentPage(requestedPage);
        return;
      }

      setLoading(true);
      if (page) {
        setCurrentPage(parseInt(page));
        let a = await dispatch(
          getTableKabKot(
            `kota-kabupaten`,
            page,
            search_by,
            sort_by,
            sort_type,
            province,
          ),
        );
        if (a) {
          setLoading(false);
        }
      } else {
        let a = await dispatch(
          getTableKabKot(
            `kota-kabupaten`,
            1,
            search_by,
            sort_by,
            sort_type,
            province,
          ),
        );
        if (a) {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [dispatch]);

  const handleSelectProv = async (event) => {
    var url = new URL(window.location.href);
    var province = url.searchParams.get("province");
    if (province) {
      url.searchParams.set("province", event.target.value);
    } else {
      url.searchParams.append("province", event.target.value);
    }
    window.history.pushState({}, null, url);

    var page = url.searchParams.get("page");
    if (page) {
      url.searchParams.set("page", 1);
    } else {
      url.searchParams.append("page", 1);
    }
    window.history.pushState({}, null, url);
    setProvince(event.target.value);
    setLoading(true);
    let a = await dispatch(
      getTableKabKot(
        `kota-kabupaten`,
        1,
        search,
        sortBy,
        sortType,
        event.target.value,
      ),
    );
    if (a) {
      setLoading(false);
    }
    setCurrentPage(1);
  };
  const handleSearch = (event) => {
    setsearch(event.target.value);
    let temp = event.target.value;
    var timeout;
    var delay = 500;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(async () => {
      if (temp === event.target.value) {
        var url = new URL(window.location.href);
        var search_by = url.searchParams.get("search_by");
        if (search_by || search_by === "") {
          url.searchParams.set("search_by", event.target.value);
        } else {
          url.searchParams.append("search_by", event.target.value);
        }
        window.history.pushState({}, null, url);

        var page = url.searchParams.get("page");
        if (page) {
          url.searchParams.set("page", 1);
        } else {
          url.searchParams.append("page", 1);
        }
        window.history.pushState({}, null, url);

        setLoading(true);
        let a = await dispatch(
          getTableKabKot(
            `kota-kabupaten`,
            1,
            event.target.value,
            sortBy,
            sortType,
            filterProvince,
          ),
        );
        if (a) {
          setLoading(false);
        }
        setCurrentPage(1);
      }
    }, delay);
  };
  const handleRefresh = async () => {
    setLoading(true);
    const response = await dispatch(
      getTableKabKot(
        `kota-kabupaten`,
        currentPage,
        search,
        sortBy,
        sortType,
        filterProvince,
      ),
    );
    if (response) {
      setLoading(false);
    }
  };
  const handleSort = async (event) => {
    var url = new URL(window.location.href);
    var sort_by = url.searchParams.get("sort_by");
    if (sort_by) {
      url.searchParams.set("sort_by", event.target.value);
    } else {
      url.searchParams.append("sort_by", event.target.value);
    }
    window.history.pushState({}, null, url);

    setSortBy(event.target.value);
    setLoading(true);
    let a = await dispatch(
      getTableKabKot(
        `kota-kabupaten`,
        currentPage,
        search,
        event.target.value,
        sortType,
        filterProvince,
      ),
    );
    if (a) {
      setLoading(false);
    }
  };
  const handleSortType = async (event) => {
    var url = new URL(window.location.href);
    var sort_type = url.searchParams.get("sort_type");
    if (sort_type) {
      url.searchParams.set("sort_type", event.target.value);
    } else {
      url.searchParams.append("sort_type", event.target.value);
    }
    window.history.pushState({}, null, url);

    setSortType(event.target.value);
    setLoading(true);
    let a = await dispatch(
      getTableKabKot(
        `kota-kabupaten`,
        currentPage,
        search,
        sortBy,
        event.target.value,
        filterProvince,
      ),
    );
    if (a) {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <Gap height={20} />

      {/* Page Header with Title and Refresh */}
      <div className="exco-page-header">
        <h1 className="exco-page-title">EXCO Kabupaten/Kota</h1>
        <div className="exco-refresh-wrapper">
          <RefreshButton onClick={handleRefresh} loading={loading} />
        </div>
      </div>
      <Gap height={20} />

      {/* Filter Row */}
      <div className="exco-filter-row">
        <select
          className="exco-filter-dropdown"
          onChange={handleSelectProv}
          value={filterProvince}
          style={{
            maxWidth: "none",
            minWidth: "150px",
            flexGrow: 1,
            boxSizing: "border-box",
            height: "36px",
            padding: "0 26px 0 10px",
            fontSize: "13px",
          }}
        >
          {provinces.map((list, key) => (
            <option value={list.kode_prov_bps} key={key}>
              Provinsi: {list.nama_prov_kemdagri}
            </option>
          ))}
        </select>

        <select
          className="exco-filter-dropdown"
          onChange={handleSort}
          value={sortBy}
          style={{
            maxWidth: "none",
            minWidth: "150px",
            flexGrow: 1,
            boxSizing: "border-box",
            height: "36px",
            padding: "0 26px 0 10px",
            fontSize: "13px",
          }}
        >
          <option value="nama_kantor">Urutkan: Nama Kab/Kota</option>
          <option value="id_kantor">Urutkan: Kode Wilayah</option>
        </select>

        <select
          className="exco-filter-dropdown"
          onChange={handleSortType}
          value={sortType}
          style={{
            maxWidth: "none",
            minWidth: "150px",
            flexGrow: 1,
            boxSizing: "border-box",
            height: "36px",
            padding: "0 26px 0 10px",
            fontSize: "13px",
          }}
        >
          <option value="asc">A-Z (Ascending)</option>
          <option value="desc">Z-A (Descending)</option>
        </select>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "0 10px",
            maxWidth: "none",
            minWidth: "200px",
            flexGrow: 4,
            boxSizing: "border-box",
            height: "36px",
          }}
        >
          <SearchIcon style={{ color: "#9CA3AF", marginRight: "8px" }} />
          <input
            type="text"
            placeholder="Search by kab/kota"
            value={search || ""}
            onChange={handleSearch}
            style={{
              border: "none",
              outline: "none",
              width: "100%",
              fontSize: "13px",
              color: "#1a1a1a",
              background: "transparent",
            }}
          />
        </div>
      </div>
      <ExcoCardView
        loading={loading}
        data={dataExcoKabKot?.data?.data}
        currentPage={currentPage}
        type="kabkot"
        nameExco="EXCO Kabupaten/Kota"
      />
      {dataExcoKabKot?.data?.data?.length > 0 && (
        <div
          style={{
            justifyContent: "flex-end",
            display: "flex",
            marginTop: "10px",
          }}
        >
          <Pagination
            count={Math.ceil(dataExcoKabKot?.data?.total_items / 10)}
            variant="outlined"
            shape="rounded"
            page={currentPage}
            onChange={handlePagination}
            className={classes.root}
          />
        </div>
      )}
      <Gap height={20} />
      <div className="footer-content"></div>
    </div>
  );
};

export default ExcoKabKot;
